import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import { TurfTalk } from "@/api/client";
import { unreadFromResponse, formatBadge } from "@/lib/notifications";

const POLL_MS = 45000;

// Compact bell with an unread badge. Polls the shared unread-count endpoint;
// fails silently (hides the badge) so a backend hiccup never breaks the shell.
export function NotificationBell({ className = "", testid = "nav-notifications-bell" }) {
  const navigate = useNavigate();
  const [count, setCount] = useState(0);
  const timer = useRef(null);

  useEffect(() => {
    let alive = true;
    const tick = async () => {
      try {
        const r = await TurfTalk.notificationsUnread();
        if (alive) setCount(unreadFromResponse(r));
      } catch { if (alive) setCount(0); }
    };
    tick();
    timer.current = setInterval(tick, POLL_MS);
    return () => { alive = false; if (timer.current) clearInterval(timer.current); };
  }, []);

  const badge = formatBadge(count);
  return (
    <button
      onClick={() => navigate("/notifications")}
      aria-label={badge ? `Notifications, ${count} unread` : "Notifications"}
      data-testid={testid}
      className={`relative grid place-items-center rounded-lg text-white/60 hover:text-white hover:bg-white/5 transition-colors ${className}`}
    >
      <Bell size={18} />
      {badge && (
        <span
          data-testid="notifications-unread-badge"
          className="absolute -top-0.5 -right-0.5 min-w-[16px] h-[16px] px-1 grid place-items-center rounded-full bg-[#2F7D32] text-white text-[10px] font-semibold leading-none"
        >
          {badge}
        </span>
      )}
    </button>
  );
}
